import kamala from '../../kamala'
import TimerPicker from './TimePicker'

TimerPicker.install = function (Vue) {
  kamala(Vue)
  Vue.component(TimerPicker.name, TimerPicker)
}

export default TimerPicker
